/* eslint-disable react/prop-types */
// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiProgress from "components/VuiProgress";
import VuiButton from "components/VuiButton";

import { Link } from "react-router-dom";

// @mui material components
import Icon from "@mui/material/Icon";

function Name({ name, email }) {
  return (
    <VuiBox display="flex" alignItems="center" px={1} py={0.5}>
      <VuiBox display="flex" flexDirection="column">
        <VuiTypography variant="button" color="white" fontWeight="medium">
          {name}
        </VuiTypography>
        <VuiTypography variant="caption" color="text">
          {email}
        </VuiTypography>
      </VuiBox>
    </VuiBox>
  );
}

const generateLeadsTableData = (leads, onFlagLead) => {
  const columns = [
    { name: "nome", align: "left" },
    { name: "telefone", align: "left" },
    { name: "ip", align: "center" },
    { name: "hora de acesso", align: "center" },
    { name: "risco", align: "center" },
    { name: "alertas", align: "left" },
    { name: "ação", align: "center" },
    { name: "detalhes", align: "center" },
  ];

  const rows = leads.map((lead) => {
    let riskValue = (lead.fraudScore || 0) * 100;
    let riskColor;
    let riskLabel;
    let displayText;

    if (lead.fraudsterId) {
      riskLabel = "Fraudador";
      riskColor = "error";
      riskValue = 100; // Força a barra a 100% para fraudadores
      displayText = riskLabel; // Mostra apenas "Fraudador"
    } else if (lead.riskLevel === "Suspeito" || lead.riskLevel === "high") {
      riskLabel = "Suspeito";
      riskColor = "warning";
      displayText = `${riskLabel} ${riskValue.toFixed(0)}%`;
    } else {
      riskLabel = "Normal";
      riskColor = "success";
      displayText = `${riskLabel} ${riskValue.toFixed(0)}%`;
    }

    const formattedDate = new Date(lead.createdAt).toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });

    const fingerprint = lead.fingerprintHash || lead.fingerprintHashFallback;

    return {
      nome: <Name name={lead.name || 'N/A'} email={lead.email || 'N/A'} />,
      telefone: lead.phone || 'N/A',
      ip: lead.ipAddress,
      "hora de acesso": formattedDate,
      risco: (
        <VuiBox sx={{ width: '100px' }}>
          <VuiTypography variant="caption" color="text" sx={{ mb: 0.5 }}>
            {displayText}
          </VuiTypography>
          <VuiProgress value={riskValue} color={riskColor} variant="gradient" sx={{ background: "#2D2E5F" }} />
        </VuiBox>
      ),
      alertas: (
        <VuiBox display="flex" flexDirection="column" maxWidth="220px">
          {(lead.flaggedReasons && lead.flaggedReasons.length) ? (
            lead.flaggedReasons.map((reason, idx) => (
              <VuiTypography key={`${lead.id}-reason-${idx}`} variant="caption" color="white" sx={{ mb: 0.5 }}>
                • {reason}
              </VuiTypography>
            ))
          ) : (
            <VuiTypography variant="caption" color="text">
              Sem alertas externos
            </VuiTypography>
          )}
        </VuiBox>
      ),
      ação: (
        <VuiButton
          variant="outlined"
          color="info"
          size="small"
          onClick={() => onFlagLead(lead)}
          disabled={!!lead.fraudsterId}
        >
          {lead.fraudsterId ? "Marcado" : "Marcar Fraude"}
        </VuiButton>
      ),
      detalhes: (
        <Link to={fingerprint ? `/dossier/by-fingerprint/${fingerprint}` : "#"}>
          <VuiBox
            sx={{
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              cursor: fingerprint ? "pointer" : "not-allowed",
              transition: "background-color 0.2s ease-in-out",
              "&:hover": {
                backgroundColor: fingerprint ? "rgba(255, 255, 255, 0.1)" : "transparent",
              },
              opacity: fingerprint ? 1 : 0.5,
            }}
          >
            <Icon style={{ color: "white" }} fontSize="small">
              visibility
            </Icon>
          </VuiBox>
        </Link>
      ),
    };
  });

  return { columns, rows };
};

export default generateLeadsTableData;
